export default __webpack_public_path__ + "static/media/Sentiment_01_Result_01.5c9cef06.png";